/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
    TransactionTypeToJSONTyped,
} from './TransactionType';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';
import type { TransactionStatus } from './TransactionStatus';
import {
    TransactionStatusFromJSON,
    TransactionStatusFromJSONTyped,
    TransactionStatusToJSON,
    TransactionStatusToJSONTyped,
} from './TransactionStatus';

/**
 * Payload to update an existing transaction
 * @export
 * @interface UpdateTransactionRequest
 */
export interface UpdateTransactionRequest {
    /**
     * 
     * @type {TransactionType}
     * @memberof UpdateTransactionRequest
     */
    transactionType?: TransactionType;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionRequest
     */
    amountCents?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateTransactionRequest
     */
    feeCents?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    transactionDate?: string;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof UpdateTransactionRequest
     */
    paymentMethod?: PaymentMethod;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    referenceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    payee?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    payer?: string | null;
    /**
     * 
     * @type {TransactionStatus}
     * @memberof UpdateTransactionRequest
     */
    status?: TransactionStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateTransactionRequest
     */
    notes?: string | null;
}



/**
 * Check if a given object implements the UpdateTransactionRequest interface.
 */
export function instanceOfUpdateTransactionRequest(value: object): value is UpdateTransactionRequest {
    return true;
}

export function UpdateTransactionRequestFromJSON(json: any): UpdateTransactionRequest {
    return UpdateTransactionRequestFromJSONTyped(json, false);
}

export function UpdateTransactionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTransactionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionType': json['transactionType'] == null ? undefined : TransactionTypeFromJSON(json['transactionType']),
        'amountCents': json['amountCents'] == null ? undefined : json['amountCents'],
        'feeCents': json['feeCents'] == null ? undefined : json['feeCents'],
        'transactionDate': json['transactionDate'] == null ? undefined : json['transactionDate'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : PaymentMethodFromJSON(json['paymentMethod']),
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'payee': json['payee'] == null ? undefined : json['payee'],
        'payer': json['payer'] == null ? undefined : json['payer'],
        'status': json['status'] == null ? undefined : TransactionStatusFromJSON(json['status']),
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateTransactionRequestToJSON(json: any): UpdateTransactionRequest {
    return UpdateTransactionRequestToJSONTyped(json, false);
}

export function UpdateTransactionRequestToJSONTyped(value?: UpdateTransactionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionType': TransactionTypeToJSON(value['transactionType']),
        'amountCents': value['amountCents'],
        'feeCents': value['feeCents'],
        'transactionDate': value['transactionDate'],
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'referenceNumber': value['referenceNumber'],
        'payee': value['payee'],
        'payer': value['payer'],
        'status': TransactionStatusToJSON(value['status']),
        'notes': value['notes'],
    };
}

